var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-header"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-12"},[_c('h1',{staticClass:"m-0"},[_vm._v(_vm._s(_vm.headerTitle))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }